<template>
  <div class="page">
    <img
      src="/static/banner3.jpg"
      style="width: 100%;"
    />
    <div class="page__bd">
      <div
        class="weui-cells"
        style="margin-top: 0px;"
      >
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="qujianTips"
        >
          <div class="weui-cell__bd">
            <p>快速取件</p>
          </div>
          <div class="weui-cell__ft">节约时间</div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="jijianTips"
        >
          <div class="weui-cell__bd">
            <p>自助寄件</p>
          </div>
          <div class="weui-cell__ft">在线下单</div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="paotuiTips"
        >
          <div class="weui-cell__bd">
            <p>校内跑腿</p>
          </div>
          <div class="weui-cell__ft">应你所需</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    qujianTips() {
      this.$router.push("/qujianTips");
    },
    jijianTips() {
      this.$router.push("/jijianTips");
    },
    paotuiTips() {
      this.$router.push("/paotuiTips");
    }
  }
};
</script>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/infos/Help.vue